var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('icon',{attrs:{"name":"briefcase","scale":"2"}}),_vm._v(" "),_c('icon',{attrs:{"name":"plus","scale":"1"}}),_vm._v(" "),_c('router-link',{attrs:{"tag":"a","to":_vm.enedisCaseRoute}},[_vm._v("\n        Ajouter une affaire\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f97d04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/AddEditEnedisCaseButton.vue
// module id = null
// module chunks = 